
































import Vue from 'vue'
import Component from 'vue-class-component'
import Avatar from '@app/componentlib/src/views/components/Avatar.vue'
import { CV } from '@app/componentlib/common/types/CVTypes'
import ImageCard from './ImageCard.vue'
import { ga } from '@app/componentlib/src/application/analytics'

@Component<CardList>({
  props: {
    items: Array,
    t: Object
  },
  components: {
    Avatar,
    ImageCard
  }
})

export default class CardList extends Vue {
  /**
   * Props variables
   */
  items: [] | undefined
  t: object | undefined


  /**
   * Component state variables
   */


  /**
   * Lifecycle
   */


  /**
   * Getters
   */
  getItems (): [] | undefined {
    return undefined
  }

  get itemsTemplate () : CV[] | undefined {
    if(this.items !== undefined) {
      const templates = this.items.filter((i: CV) => i.template === true)
      return templates
    }
    return undefined
  }

  get itemsExample () : CV[] | undefined {
    if(this.items !== undefined) {
      return this.items.filter((i: CV) => i.template !== true)
    }
    return undefined
  }

  /**
   * Methods
   */
  selectItem (item:CV) {
    ga.event({
      category: 'CV Tool',
      action: 'CV Selected TEST',
      label: `${item.templateId} ${item.title} ${item.language}`
    })

    this.$emit('clickItem', item)
  }
}
